export default __webpack_public_path__ + "static/Pulzion24-80bd18f6d983f9aa7996840a78084160.jpg";